import { render, staticRenderFns } from "./ReviewsPortalEditar.vue?vue&type=template&id=846dc7be&scoped=true&"
import script from "./ReviewsPortalEditar.vue?vue&type=script&lang=js&"
export * from "./ReviewsPortalEditar.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsPortalEditar.vue?vue&type=style&index=0&id=846dc7be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846dc7be",
  null
  
)

export default component.exports